import { Injectable } from '@angular/core';
import { environment } from '@dxc/environments';
import { FeatureFlag } from '@shared/types';

interface CustomerFeatures {
  [customer: string]: FeatureFlag[];
}

@Injectable({ providedIn: 'root' })
export class CustomerFeaturesService {
  private customerFeatures: CustomerFeatures = {
    blockchain: [
      // specific modules
      'moduleHomeMyCases',
      'moduleCasesOpen',
      'moduleCasesClosed',
      'moduleCasesCustomer',
      'moduleCasesElliptic',
      'moduleCasesTransaction',
      'moduleCasesTravelRule',
      'moduleRuleEngine',
      'moduleDxTective',
      'moduleCustomers',
      'moduleSar',
      'moduleCharts',
      'moduleLeadership',
      'moduleUsers',
      'moduleAuditTrail',
      'moduleUploadData',
      'moduleMyAccount',
      'moduleAppSettings',

      // specific routes
      'routeAppSettingsRetailRiskFactors',
      'routeAppSettingsCorporateRiskFactors',
      'routeAppSettingsAdverseMedia',
      'routeAppSettingsHifcaHidta',
      'routeUserProfile',
      'routeAppSettingsScreeningLists',

      // specific components
      'componentMyCasesStats'
    ],
    esketit: [
      // specific modules
      'moduleHomeMyCases',
      'moduleCasesOpen',
      'moduleCasesClosed',
      'moduleCasesCustomer',
      'moduleCasesTransaction',
      'moduleRuleEngine',
      'moduleDxTective',
      'moduleCustomers',
      'moduleSar',
      'moduleCharts',
      'moduleLeadership',
      'moduleUsers',
      'moduleAuditTrail',
      'moduleMyAccount',
      'moduleAppSettings',

      // specific routes
      'routeAppSettingsRetailRiskFactors',
      'routeAppSettingsCorporateRiskFactors',
      'routeAppSettingsAdverseMedia',
      'routeAppSettingsHifcaHidta',
      'routeAppSettingsScreeningLists',

      // specific components
      'componentMyCasesStats'
    ],
    uba: [
      // specific modules
      'moduleHomeMyCases',
      'moduleCasesOpen',
      'moduleCasesClosed',
      'moduleCasesTransaction',
      'moduleRuleEngine',
      'moduleDxTective',
      'moduleCustomers',
      'moduleSar',
      'moduleCharts',
      'moduleLeadership',
      'moduleUsers',
      'moduleAuditTrail',
      'moduleUploadData',
      'moduleMyAccount',
      'moduleAppSettings',

      // specific routes
      'routeAppSettingsRetailRiskFactors',
      'routeAppSettingsCorporateRiskFactors',
      'routeAppSettingsAdverseMedia',
      'routeAppSettingsHifcaHidta',
      'routeAppSettingsScreeningLists',

      // specific components
      'componentMyCasesStats'
    ],
    abrdn: [
      // specific modules
      'moduleHomeAbrdnTrades',
      'moduleCasesOpen',
      'moduleCasesClosed',
      'moduleFunds',
      'moduleAbrdnSettings',
      'moduleRuleEngine',

      // specific routes
      'routeOpenCasesAbrdnOrders',
      'routeClosedCasesAbrdnOrders',
      'routeUserProfile'
    ]
  };

  hasFeature(feature: FeatureFlag): boolean {
    const currentCustomer = environment.customer;
    // console.log(`🚀 ~ hasFeature:`, feature);
    // console.log(`🚀 ~ currentCustomer:`, currentCustomer);
    return this.customerFeatures[currentCustomer]?.includes(feature) ?? false;
  }
}
